import { getImageHashes, getVideoImageHashes } from '../../../../forms/Facebook/AdForms/AdFacebookEdit/helpers'

export const getAllImageHashesFromAdsList = adsList => {
  const accountHashesMap = adsList.reduce((acc, ad) => {
    const imageHashes = getImageHashes(ad)
    const videoImageHashes = getVideoImageHashes(ad)
    const accountId =
      ad.ad_account_id ||
      ad.creative?.account_id ||
      // When the ad is created in response we have ad account id in 'account' field
      ad.account

    if (!acc[accountId]) {
      acc[accountId] = new Set()
    }

    imageHashes.forEach(hash => {
      if (hash) {
        acc[accountId].add(hash)
      }
    })

    videoImageHashes.forEach(hash => {
      if (hash) {
        acc[accountId].add(hash)
      }
    })

    return acc
  }, {})

  return Object.entries(accountHashesMap).map(([account, hashesSet]) => ({
    account,
    hashes: Array.from(hashesSet)
  }))
}
